import { Form, Radio } from 'antd';

import { AdminApprovalMap } from '../../types/constants';

export const AdminConfirmField = () => {
  return (
    <Form.Item
      label="Admin approval"
      name="need_confirm"
      layout="vertical"
      required
      labelCol={{ flex: 1 }}
      rules={[{ required: true, message: 'Admin approval is required' }]}
    >
      <Radio.Group>
        <Radio value={false} defaultChecked>
          {AdminApprovalMap.get(false)}
        </Radio>
        <Radio value={true}>{AdminApprovalMap.get(true)}</Radio>
      </Radio.Group>
    </Form.Item>
  );
};
